import React from "react";

const ButtonTitle = ({ title }) => {
  const backgroundStyle = {
    background: "linear-gradient(to right, #FDCC05, #1D2A9D)",
    padding: "15px",
    borderRadius: "8px",
    color: "white",
    fontWeight: "bold",
  };
  return (
    <div style={backgroundStyle}>
      <h2>{title}</h2>
    </div>
  );
};

export default ButtonTitle;
